<template>
  <div>
    123213123
  </div>
</template>

<script lang="ts" setup>

</script>

<style lang="scss" scoped>

</style>